import { FilterInput } from "../types";
import { BulkMessageLocationEnum } from "@/__generated__/graphql";

export function fixLocations(location: FilterInput): FilterInput {
  if (location.options?.length) {
    const { options } = location;
    const intlIndex = options.findIndex(
      ({ value }) => value === BulkMessageLocationEnum.AllInternationalStudents,
    );
    const intlOption = options.splice(intlIndex, 1)[0];
    const usIndex = options.findIndex(
      ({ value }) => value === BulkMessageLocationEnum.AllUsStudents,
    );
    const usOption = options.splice(usIndex, 1)[0];
    location.options?.unshift(intlOption);
    location.options?.unshift(usOption);
  }

  return location;
}
